// extracted by mini-css-extract-plugin
export default {"page":"steps_page__wFoV0","contentWrapper":"steps_contentWrapper__ywM5k"};